export default "__VITE_ASSET__$dC2IYZi__"